import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled, ParentSelectBox } from '../../DiabeticForm/sub-form-sections/PresentingComplaintSection'
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import { asssessmentFootOptions, nailInfection, orthopedicMotionOptions } from './formFootOptions';
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm'; 


const FootAssesment = (props) => {
    const {control, errors, getValues} = props
  return (
    <ParentContainerSection heading="Section E – General assessment of the foot">
    <CustomInputLable sx={{ marginBottom: "0.5rem"}}>General assessment of the foot</CustomInputLable>
    <InputContainer   sx={{ marginLeft: "4px !important" }}>
      <CheckboxController
        name={"foot_assesment.foot_assesment"}
        isRow={true}
        isMultiCheckbox={true}
        control={control}
        errors={errors}
        options={asssessmentFootOptions}
        isHorizantalPadding={true}
        isCustomPadding
        isDisabled
        size="small" />
    </InputContainer>
    <CustomInputLable sx={{ marginBottom: "0.5rem"}}>Nail Infection</CustomInputLable>
    <InputContainer  sx={{ marginLeft: "4px !important" }}>
      <CheckboxController
        name={"foot_assesment.nail_infection"}
        isRow={true}
        isMultiCheckbox={true}
        control={control}
        errors={errors}
        options={nailInfection}
        isHorizantalPadding={true}
        isCustomPadding
        isDisabled
        size="small" />
    </InputContainer>

    <CustomInputLable required sx={{ marginBottom: "0.5rem"}}>Orthopedic range of motion</CustomInputLable>
    <InputContainer sx={{ marginLeft: "4px !important" }}>
      <RadioButtonController
        name="foot_assesment.orthopedic_motion"
        isRow
        control={control}
        errors={errors}
        options={orthopedicMotionOptions}
        isDisabled
      />
    </InputContainer>

  </ParentContainerSection>

/*  */
    // <ParentContainerSection heading="Section E – General assessment of the foot">
                 
    //             <Box sx={{ display: "flex", gap: "1rem", alignItems: "center",  }}>
    //             <InputLabelStyled sx={{ whiteSpace: "normal", minWidth:"180px"}}>General assessment of the foot</InputLabelStyled>
    //                      <CheckboxController
    //                             name="foot_assesment.foot_assesment"
    //                             isRow={true}
    //                             isMultiCheckbox={true}
    //                             control={control}
    //                             errors={errors}
    //                             options={asssessmentFootOptions}
    //                             isHorizantalPadding={true}
    //                             isDisabled
    //                         />
    //             </Box>

    //             <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
    //             <InputLabelStyled sx={{ whiteSpace: "normal",  minWidth:"180px"}}>Nail Infection</InputLabelStyled>
    //                      <CheckboxController
    //                             name="foot_assesment.nail_infection"
    //                             isRow={true}
    //                             isMultiCheckbox={true}
    //                             control={control}
    //                             errors={errors}
    //                             options={nailInfection}
    //                             isHorizantalPadding={true}
    //                             isDisabled
    //                         />
    //             </Box>
    //             <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
    //             <InputLabelStyled sx={{ whiteSpace: "normal",  minWidth:"180px"}}>Orthopedic range of motion</InputLabelStyled>
    //                      <RadioButtonController
    //                             name="foot_assesment.orthopedic_motion"
    //                             isRow={true}
    //                             control={control}
    //                             errors={errors}
    //                             options={orthopedicMotionOptions}
    //                             isHorizantalPadding={true}
    //                             isDisabled
    //                         />
    //             </Box>

    //             </ParentContainerSection>

  )
}

export default FootAssesment